// Поиск по карточкам фирм на /order_services.
// Фильтрует по data-firm-name (вмещает translate_name[locale] в lower-case)
// и data-firm-country. Обновляет счётчик и показывает empty-state.
(function () {
    var input = document.querySelector('[data-firms-filter]');
    if (!input) return;

    var list      = document.querySelector('[data-firms-list]');
    var cards     = list ? list.querySelectorAll('.firm-card') : [];
    var counter   = document.querySelector('[data-firms-counter]');
    var noResults = document.querySelector('[data-firms-no-results]');
    var clearBtn  = document.querySelector('[data-firms-filter-clear]');
    var total     = cards.length;

    function normalize(s) {
        return (s || '').toString().toLowerCase().trim();
    }

    function apply() {
        var q = normalize(input.value);
        var shown = 0;

        for (var i = 0; i < cards.length; i++) {
            var card = cards[i];
            var name = card.getAttribute('data-firm-name') || '';
            var country = card.getAttribute('data-firm-country') || '';
            var match = q === '' || name.indexOf(q) !== -1 || country.indexOf(q) !== -1;
            card.hidden = !match;
            if (match) shown++;
        }

        if (counter) counter.textContent = shown;
        if (noResults) noResults.hidden = shown > 0;
        if (clearBtn) clearBtn.hidden = q === '';
    }

    var debounce = null;
    input.addEventListener('input', function () {
        clearTimeout(debounce);
        debounce = setTimeout(apply, 80);
    });

    if (clearBtn) {
        clearBtn.addEventListener('click', function () {
            input.value = '';
            apply();
            input.focus();
        });
    }

    // Esc → очистить
    input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && input.value !== '') {
            input.value = '';
            apply();
        }
    });
})();
